export { Anchor } from './Anchor';
export type { AnchorComponentProps } from './Anchor';
